import { fetchJSON } from '../internal/api.js';
import { getApiUrl } from '../utils/getApiUrl.js';
function isContracts(json) {
    const contracts = json;
    return (contracts != null &&
        typeof contracts.inbox === 'string' &&
        typeof contracts.outbox === 'string');
}
export async function getContracts(params = {}) {
    const apiUrl = getApiUrl(params?.environment);
    const json = await fetchJSON(`${apiUrl}/contracts`);
    if (!isContracts(json))
        throw new Error('Unexpected /contracts response');
    return json;
}
//# sourceMappingURL=getContracts.js.map